module.exports = __webpack_public_path__ + "img/ski_sub_title4.763bb36a.jpg";